﻿import React, {FC} from 'react';
import {GridProps} from "@mui/material";
import {SearchFilterGridChild} from './styles'

const SearchFilterAndSortGridItem: FC<GridProps> = ({ children, ...rest}) => {
  return <SearchFilterGridChild item {...rest}>
    {children}
  </SearchFilterGridChild>
}

export default SearchFilterAndSortGridItem;
